import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import moment from "moment";
import { styled } from "@mui/material";
import Report from "./report/Report";
import LeaveReport from "../leaveManagement/admin/LeaveReport";
import ComplienceReport from "./attendance/ComplienceReport";
import Department from "./department/department";
import Designation from "./designation/designation";


const date = new Date();
const monthName = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
let previousMonth = date.getMonth();
let displayMonthName = monthName.find((ele, i) => {
  return i === previousMonth - 1;
});

let m = date.getMonth() + 1;
let m2 = date.getMonth();
let y = date.getFullYear();
let dateString = y + "-" + (m <= 9 ? "0" + m : m);
let pastMonth = y + "-" + (m2 <= 9 ? "0" + m2 : m2);
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const CustomTab = styled(Tab)(() => ({
  fontSize: "1.2rem",
  fontWeight: "600",
  textTransform: "capitalize",
}));

export default function EmployeeSystemTab() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let todayDate = moment(date).format("MMMM");
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <CustomTab label={`Department`} {...a11yProps(0)} />
          <CustomTab
            label={`Designation`}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Department />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Designation />
      </TabPanel>
    </Box>
  );
}
